import Icon from './Icon'

var statuses=[
    {name:"wait",text:"Будет доступно"}
]

var StatusCard = (props) => {

    var status="";
    if (props.status=='wait') status='Ожидание'
    if (props.status=='homework') status='Ожидается домашнее задание'
    if (props.status=='done') status='Выполнено'
    if (props.status=='locked') status='Закрыто'
    if (props.status=='opened') status='Смотреть'
    


   return (<div  >
       {!props.full&&(<div className={"status-card-inner elem "+props.status}>
        <div className="statuscard-text">
                <div className="heading">{props.heading}</div>
                <div className="description">{props.description}</div>
        </div>
        <div className="statuscard-info">
         <div className="statuscard-text">{status}</div>
         <div className="statuscard-icon"><Icon name={props.status} className="status-icon"/></div>
        </div>
       </div>)}
       {props.full&&(<div style={{display:"block"}} className={"descriptor"}>
        <div className="statuscard-text">
                <div className="heading">{props.heading}</div>
                <div className="description">{props.description}</div>
        </div>
       
       </div>)}
       
       {props.children}
       <style jsx>{`
            .descriptor {
                padding:15px 0px;
            }
            .statuscard-info {
                text-align:right;
                padding-right:10px;
                padding-top:10px;
            }
            .elem {
                background-color:#F8F3FC;
                opacity:0.8;
                padding:15px;
                border-radius:7px;
                margin-bottom:15px;
                cursor:pointer
            }
            .elem.done{
                background-color:#EFFFF0;    
            }
            .elem.opened{
                background-color:#E4FBDB;    
            }
            .elem.wait{
                background-color:#F5F5F5;    
            }
            .elem.locked{
                background-color:#FBF7E1;    
            }
            .elem.homework{
                background-color:#FBFBFB;        
            }
            
            .elem:hover {
                opacity:1;
            }
            .heading{
                font-size:1.5em;
            }
            .status-card-inner{
                display:grid;
                grid-template-columns:1fr 220px;
            }
            .status-icon{
                height:45px;
            }
            .statuscard-text{
                padding-bottom:7px;
            }
            .statuscard-info{
                display:grid;
                grid-template-columns:160px 60px;
                align-items: center;
            }
            @media(max-width: 768px){
                .status-card-inner{
                    display:grid;
                    grid-template-columns:auto;
                    grid-template-rows:auto auto;
                    
                }
                .statuscard-info{
                    grid-template-columns:auto 40px;
                }
                .status-icon{
                    height:25px;
              }

            }

           `}</style>
   </div>)
}
export default StatusCard